/**
 * CloudIcon Component
 * 3D cloud illustration for the "HappyCloud Konto anlegen" step on SetupPage
 */

import cloudImage from '../../assets/images/setupCloudAccount.png'
import cloudImage2x from '../../assets/images/setupCloudAccount@2x.png'

interface CloudIconProps {
  width?: number
  className?: string
}

export const CloudIcon = ({ width = 96, className = '' }: CloudIconProps) => (
  <img
    src={cloudImage}
    srcSet={`${cloudImage} 1x, ${cloudImage2x} 2x`}
    alt=""
    className={className}
    style={{
      width,
      height: 'auto',
    }}
  />
)
